// tracking/PageViewTracker.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useTracking } from "./TrackingContext";

export default function PageViewTracker() {
  const { trackEvent } = useTracking();
  const location = useLocation();
  const prevPathRef = useRef();

  useEffect(() => {
    // wait for title updates
    requestAnimationFrame(() => {
      const page_location = window.location.href;
      const page_title = document.title || undefined;
      const prevPath = prevPathRef.current;
      const page_referrer = prevPath
        ? `${window.location.origin}${prevPath}`
        : document.referrer || undefined;

      trackEvent("page_view", { page_location, page_title, page_referrer });
      prevPathRef.current = location.pathname + location.search + location.hash;
    });
  }, [location.pathname, location.search, location.hash, trackEvent]);

  return null;
}
